export default "__VITE_ASSET__DMFH$bHU__"